import { z } from "zod";

export const brandNameSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type BrandName = z.infer<typeof brandNameSchema>;
